var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddOnGridDotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_219",
    "data-name": "Ellipse 219",
    cx: 4,
    cy: 4,
    r: 4,
    fill: "#c84e03"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddOnGridDotIcon);
export default __webpack_public_path__ + "static/media/addOn-grid-dot-icon.1948b0eab01d04596bd4025ade352760.svg";
export { ForwardRef as ReactComponent };